import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影频道",
    desc: "汇集院线佳作与经典影片，剧情、科幻、悬疑一网打尽",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage%20background%20for%20a%20movie%20channel%20featuring%20a%20vintage%20film%20reel%20and%20dim%20cinema%20hall%20seating%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20spotlighting%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20and%20atmospheric%20mood&width=800&height=600&seq=yzs-cat-movie&orientation=landscape",
  },
  {
    to: "/category/drama",
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "热播剧集与口碑长剧，古装、都市、悬疑随你挑选",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20a%20glowing%20television%20screen%20at%20night%20for%20a%20TV%20drama%20channel%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20soft%20ambient%20light%20and%20bokeh%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20inviting%20and%20comfortable%20mood&width=800&height=600&seq=yzs-cat-drama&orientation=landscape",
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative overflow-hidden rounded-lg h-40 md:h-48 border border-background-200"
        >
          <img
            src={entry.image}
            alt={entry.title}
            title={`${entry.title} - 缘之空`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-primary-950/30"></div>
          <div className="relative z-10 h-full p-6 flex flex-col justify-center">
            <span className="w-11 h-11 rounded-md bg-accent-500 flex items-center justify-center mb-3">
              <i className={`${entry.icon} text-xl text-background-50`}></i>
            </span>
            <h3 className="font-heading font-black text-background-50 text-lg md:text-xl">
              {entry.title}
            </h3>
            <p className="mt-1 text-sm text-background-200 max-w-xs">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}